import { Routes } from '@angular/router';

export const routes: Routes = [
    {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    loadComponent: () => import('./layout').then(m => m.DefaultLayoutComponent),
    data: {
      title: 'หน้าแรก'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
      },
      {
        path: 'expenses',
        loadChildren: () => import('./views/expenses/routes').then((m) => m.routes)
      },
      {
        path: 'masters/bank-master',
        loadChildren: () => import('./views/masters/bank-master/routes').then((m) => m.routes)
      },
      {
        path: 'masters/credit-card-master',
        loadChildren: () => import('./views/masters/credit-card-master/routes').then((m) => m.routes)
      },
      {
        path: 'installments',
        loadChildren: () => import('./views/installments/routes').then((m) => m.routes)
      },
    //   {
    //     path: 'icons',
    //     loadChildren: () => import('./views/icons/routes').then((m) => m.routes)
    //   },
    //   {
    //     path: 'notifications',
    //     loadChildren: () => import('./views/notifications/routes').then((m) => m.routes)
    //   },
    //   {
    //     path: 'widgets',
    //     loadChildren: () => import('./views/widgets/routes').then((m) => m.routes)
    //   },
    //   {
    //     path: 'charts',
    //     loadChildren: () => import('./views/charts/routes').then((m) => m.routes)
    //   },
    //   {
    //     path: 'pages',
    //     loadChildren: () => import('./views/pages/routes').then((m) => m.routes)
    //   }
    ]
  },
//   {
//     path: '404',
//     loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
//     data: {
//       title: 'Page 404'
//     }
//   },
//   {
//     path: '500',
//     loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
//     data: {
//       title: 'Page 500'
//     }
//   },
//   {
//     path: 'login',
//     loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
//     data: {
//       title: 'Login Page'
//     }
//   },
//   {
//     path: 'register',
//     loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
//     data: {
//       title: 'Register Page'
//     }
//   },
  { path: '**', redirectTo: 'dashboard' }
];
